<template>
    <button @click="$emit('click')" :disabled="loading">
        <slot v-if="!loading"></slot>
        <i v-else class="fa fa-spinner fa-spin"></i>
    </button>
</template>

<script>
export default {
    name: "AppButton",
    props: ['loading']
}
</script>